import './style.less';
import template from './template.html';

const controller = function($log, $scope) {
  'ngInject';
  $log.debug('Event Manger Base view activated');

  const vm = this;
  $scope.eventName = false;
};

export default {
  template,
  controller,
  controllerAs: 'baseCtrl'
};



// WEBPACK FOOTER //
// ./src/app/controllers/admin/events/event/views/base/index.js